(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medicalphone-home-enhancements"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('mph-shortcut-carousel')){
customElements.define('mph-shortcut-carousel',class extends HTMLElement{
connectedCallback(){
if(this.abort)return;
this.abort=new AbortController();const opts={signal:this.abort.signal};const track=this.querySelector('.mph-shortcuts');if(!track)return;
const links=Array.from(track.querySelectorAll('a')),controls=this.querySelector('.mph-shortcut-controls'),pause=this.querySelector('.mph-shortcut-pause'),dots=Array.from(this.querySelectorAll('[data-index]'));
const mobile=matchMedia('(max-width:900px)'),reduced=matchMedia('(prefers-reduced-motion:reduce)');
let index=0,paused=reduced.matches,visible=false,hover=false;
const update=()=>{dots.forEach((d,i)=>d.setAttribute('aria-pressed',String(i===index)));pause.textContent=paused?'Riprendi':'Pausa';pause.setAttribute('aria-label',paused?'Riprendi lo scorrimento automatico':'Metti in pausa lo scorrimento automatico');};
const go=i=>{index=(i+links.length)%links.length;const left=links[index].getBoundingClientRect().left-track.getBoundingClientRect().left+track.scrollLeft-16;track.scrollTo({left:Math.max(0,left),behavior:reduced.matches?'auto':'smooth'});update();};
const stop=()=>{paused=true;update();};
controls.hidden=false;
pause.addEventListener('click',()=>{paused=!paused;update();},opts);
dots.forEach(d=>d.addEventListener('click',()=>{stop();go(Number(d.dataset.index));},opts));
for(const name of ['pointerdown','touchstart','wheel','keydown'])track.addEventListener(name,stop,{...opts,passive:true});
track.addEventListener('focusin',stop,opts);
track.addEventListener('pointerenter',()=>hover=true,opts);track.addEventListener('pointerleave',()=>hover=false,opts);
track.addEventListener('scroll',()=>{const base=track.getBoundingClientRect().left+16;let nearest=0,distance=Infinity;links.forEach((link,i)=>{const d=Math.abs(link.getBoundingClientRect().left-base);if(d<distance){distance=d;nearest=i;}});index=nearest;update();},{...opts,passive:true});
reduced.addEventListener('change',()=>{if(reduced.matches)stop();},opts);
this.observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;},{threshold:.65});this.observer.observe(track);
this.timer=setInterval(()=>{if(!mobile.matches||reduced.matches||paused||hover||!visible||document.hidden)return;go(index+1);},6000);
update();
}
disconnectedCallback(){this.abort?.abort();this.abort=null;this.observer?.disconnect();clearInterval(this.timer);}
});
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medicalphone-product-premium"] && !Shopify.designMode) return;
  try {
    
(function(){var root=document.querySelector('[data-mpp]');if(!root)return;var main=root.querySelector('.mpp__media>img');root.querySelectorAll('.mpp__thumb').forEach(function(b){b.addEventListener('click',function(){if(main)main.src=b.dataset.src;root.querySelectorAll('.mpp__thumb').forEach(function(x){x.classList.remove('is-on')});b.classList.add('is-on')})});var input=root.querySelector('[data-variant-id]'),price=root.querySelector('[data-price]'),selected=root.querySelector('[data-selected]'),buy=root.querySelector('[data-buy]');root.querySelectorAll('.mpp__variant').forEach(function(b){b.addEventListener('click',function(){root.querySelectorAll('.mpp__variant').forEach(function(x){x.classList.remove('is-on')});b.classList.add('is-on');if(input)input.value=b.dataset.id;if(price)price.textContent=b.dataset.price;if(selected)selected.textContent=b.dataset.title;if(buy){var ok=b.dataset.available==='true';buy.disabled=!ok;buy.textContent=ok?'Aggiungi al carrello':'Non disponibile'}var u=new URL(window.location.href);u.searchParams.set('variant',b.dataset.id);history.replaceState({},'',u)})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medicalphone-repair-premium"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mp-repair-request')) {
customElements.define('mp-repair-request', class extends HTMLElement {
connectedCallback() {
if (this.controller) return;
this.controller = new AbortController();
const options = {signal:this.controller.signal};
const form = this.querySelector('form');
if (!form) return;
let step = 0;
const panels = Array.from(this.querySelectorAll('[data-step]'));
const progress = this.querySelectorAll('.mpr-progress li');
const next = this.querySelector('[data-next]');
const back = this.querySelector('[data-back]');
const send = this.querySelector('[data-send]');
const error = this.querySelector('[data-error]');
const model = form.elements.model;
const show = (index, focus = true) => {
step = index;
panels.forEach((panel,i) => {panel.hidden = i !== step;});
progress.forEach((item,i) => {if(i===step)item.setAttribute('aria-current','step');else item.removeAttribute('aria-current');});
next.hidden = step === 3;send.hidden = step !== 3;back.hidden = step === 0;
this.querySelector('[data-whatsapp]').hidden = step !== 3;error.hidden = true;
const status = this.querySelector('[data-status]');
status.textContent = status.dataset.progress + ' ' + (step+1) + ' ' + status.dataset.of + ' 4';
const track=this.querySelector('.mpr-track');
track.setAttribute('aria-valuenow',String((step+1)*25));
track.style.setProperty('--mpr-progress',((step+1)*25)+'%');
progress.forEach((item,i)=>item.classList.toggle('is-complete',i<step));
if(focus) {panels[step].querySelector('legend').focus({preventScroll:true});this.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
};
const summarize = () => {
const values = {device:form.elements.device.value,brand:form.elements.brand.value,model:form.elements.unknown.checked?this.querySelector('[data-unknown]').textContent:model.value.trim(),problem:form.elements.problem.value,notes:form.elements.notes.value.trim()};
this.querySelectorAll('[data-summary]').forEach(el => {el.textContent=values[el.dataset.summary];});
const labels = Array.from(this.querySelectorAll('.mpr-summary dt')).map(el=>el.textContent);
const lines = Object.entries(values).filter(([key])=>key!=='notes').map(([key,value],i)=>labels[i]+': '+value);
const contactLines=Array.from(this.querySelectorAll('.mpr-contact-fields label')).map((label,i)=>label.textContent+': '+(i===0?form.elements.first_name.value.trim():form.elements.last_name.value.trim()));
if(form.elements.phone.value.trim()) contactLines.push(this.querySelector('[for^="mpr-phone-"]').textContent+': '+form.elements.phone.value.trim());
lines.unshift(...contactLines);
if(values.notes) lines.push(values.notes);
send.href='https://wa.me/390743051595?text='+encodeURIComponent(JSON.parse(this.querySelector('[data-copy]').textContent)+'\n\n'+lines.join('\n'));
};
send.addEventListener('click',event=>{
form.elements.first_name.value=form.elements.first_name.value.trim();
form.elements.last_name.value=form.elements.last_name.value.trim();
const invalid=Array.from(panels[3].querySelectorAll('input')).find(el=>!el.checkValidity());
if(invalid){event.preventDefault();error.hidden=false;invalid.focus();invalid.reportValidity();return;}
error.hidden=true;summarize();
},options);
panels[3].addEventListener('input',summarize,options);
form.elements.unknown.addEventListener('change', () => {model.disabled=form.elements.unknown.checked;model.required=!form.elements.unknown.checked;},options);
form.addEventListener('submit', event => {
event.preventDefault();if(step===3)return;
if(step===1&&!form.elements.unknown.checked)model.value=model.value.trim();
const invalid=Array.from(panels[step].querySelectorAll('input,select,textarea')).find(el=>!el.checkValidity());
if(invalid){error.hidden=false;invalid.focus();invalid.reportValidity();return;}
if(step===2)summarize();show(step+1);
},options);
back.addEventListener('click',()=>show(Math.max(0,step-1)),options);
this.querySelector('[data-edit]').addEventListener('click',()=>show(0),options);
this.querySelector('.mpr-enhanced').hidden=false;show(0,false);
}
disconnectedCallback(){this.controller?.abort();this.controller=null;}
});
}

  } catch(e) { console.error(e); }
})();
})();
